enum ResolvedInvoiceStatus {
  SHOW_DOCUMENTS = "SHOW_DOCUMENTS",
  ALL_CANCELLED = "ALL_CANCELLED",
  EMISSION_IN_PROGRESS = "EMISSION_IN_PROGRESS",
  ERROR_ON_EMIT = "ERROR_ON_EMIT",
  CERT_ERROR = "CERT_ERROR",
  EMPTY_DOCUMENTS = "EMPTY_DOCUMENTS",
}

export default ResolvedInvoiceStatus;
